<template>
  <div>
    <form @submit.prevent="search" class="flex flex-col sm:flex-row gap-3 max-w-2xl mx-auto">
      <div class="sm:w-40 flex items-center gap-2">
        <span class="material-symbols-outlined text-primary text-xl">location_on</span>
        <select
          v-model="selectedRegion"
          class="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary"
          :disabled="loading"
          @change="onRegionChanged"
        >
          <option v-for="region in regions" :key="region.code" :value="region.code">
            {{ region.name }}
          </option>
        </select>
      </div>
      <div class="sm:w-48 flex items-center gap-2">
        <span class="material-symbols-outlined text-primary text-xl">category</span>
        <select
          v-model="selectedCategory"
          class="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary"
          :disabled="loading"
          @change="onCategoryChanged"
        >
          <option v-for="cat in categories" :key="cat.id" :value="cat.id">
            {{ cat.name }}
          </option>
        </select>
      </div>
    </form>
  </div>
</template>

<script>
import { trendsStore } from '@/store/trends';

export default {
  name: 'SearchForm',
  props: {
    regionCode: {
      type: String,
      default: 'US'
    },
    regions: {
      type: Array,
      default: () => []
    },
    categoryId: {
      type: String,
      default: ''
    },
    categories: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search', 'regionChange', 'categoryChange', 'reset'],
  computed: {
    selectedRegion: {
      get() {
        return trendsStore.getters.currentRegion;
      },
      set(value) {
        trendsStore.dispatch('updateSelectedRegion', value);
      }
    },
    selectedCategory: {
      get() {
        return trendsStore.getters.currentCategory;
      },
      set(value) {
        trendsStore.dispatch('updateSelectedCategory', value);
      }
    }
  },
  watch: {
    regions: {
      handler(newRegions) {
        if (newRegions.length > 0) {
          trendsStore.dispatch('initializeRegions', newRegions);
        }
      },
      immediate: true
    },
    categories: {
      handler(newCategories) {
        if (newCategories.length > 0) {
          trendsStore.dispatch('initializeCategories', newCategories);
        }
      },
      immediate: true
    },
    regionCode(newVal) {
      if (newVal !== this.selectedRegion) {
        this.selectedRegion = newVal;
      }
    },
    categoryId(newVal) {
      if (newVal !== this.selectedCategory) {
        this.selectedCategory = newVal;
      }
    },
    selectedRegion(newVal) {
      // Emit to parent so composable stays in sync
      this.$emit('regionChange', newVal);
    },
    selectedCategory(newVal) {
      // Emit to parent so composable stays in sync
      this.$emit('categoryChange', newVal);
    }
  },
  methods: {
    search() {
      this.$emit('search');
    },
    onRegionChanged() {
      this.$emit('regionChange', this.selectedRegion);
      this.$emit('reset');
    },
    onCategoryChanged() {
      this.$emit('categoryChange', this.selectedCategory);
      this.$emit('reset');
    }
  }
};
</script>
